import { Pagination, SortedSide } from '@ekkogmbh/apisdk';
import React, { useCallback } from 'react';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  label: string;
  value?: SortedSide;
  onChange: (sortedSide?: SortedSide) => void;
  disabled?: boolean;
}
export const SortedSideSelect = ({ label, value, onChange, disabled }: Props): React.JSX.Element => {
  const { api } = useEkko();
  const fetchItems = useCallback((pagination: Pagination) => api.getSortedSides(pagination), [api]);

  return (
    <PaginatedSelect
      optional
      label={label}
      disabled={disabled}
      value={value}
      fetchPaginatedItems={fetchItems}
      itemId={(item: SortedSide) => item.name + '..' + item.node.id}
      itemRender={(item: SortedSide) => item.name}
      onChange={(side) => onChange(side as SortedSide | undefined)}
    />
  );
};
